import { useContext } from 'react';
import { ClientError } from 'utils/errors/client-errors';
import { Advocacy } from './advocacy.context';

// This hook is helpful for typescript because it returns an object of type AdvocacyContext.
// If we were to just use useContext(Advocacy), it would return AdvocacyContext | undefined
// and we'd have to assert that it is defined everywhere we use it
export const useAdvocacyContext = () => {
  const context = useContext(Advocacy);
  if (!context) {
    throw new ClientError(
      'useAdvocacyContext must be used within an AdvocacyProvider'
    );
  }
  return context;
};
